var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-n3 mt-n3"},[_c('ReminderBar'),_c('TotalStats'),_c('Cover'),_c('CallToAction'),_c('DonorList'),_c('Campaign'),_c('DonorProfile'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }